import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';


@Injectable()
export class AuthGuardService implements CanActivate  {

  private _lastCheck: number;

  private _sendToLogin(): Observable<boolean> {
    this._router.navigateByUrl('/login');
    return Observable.of(false);
  }

  constructor(private _router: Router, private _auth: AuthService) { }

  canActivate(): Observable<boolean> {

    //return Observable.of(true);

    if( this._auth.hasToken() ) {
      const d: number = new Date().getTime();
      if(this._lastCheck && (d - this._lastCheck < 30000)) {
        return Observable.of(true);
      } else {
        return this._auth.verifyToken()
        .map(response => {
          if(response == false)
          {
            return this._sendToLogin();
          } else {
            this._lastCheck = d;
            return true;
          }
        })
        .catch((err) => {
          this._router.navigateByUrl('/login');
          return Observable.of(false);
        })
      }
    } else {
      return this._sendToLogin();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth-guard.service.ts